import React, { FC } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';

const Transition = React.forwardRef(
  (
    props: TransitionProps & {
      children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
  ) => (
    <Slide
      direction="up"
      ref={ref}
      {...props}
    />
  ),
);

interface IDialogConfirm {
  title: string;
  description: string;
  open: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
}

export const DialogConfirm: FC<IDialogConfirm> = ({ title, description, open, handleClose, handleConfirm }) => (
  <Dialog
    open={open}
    TransitionComponent={Transition}
    keepMounted
    onClose={handleClose}
    aria-describedby="alert-dialog-slide-description"
  >
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-slide-description">{description}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose}>Отмена</Button>
      <Button onClick={handleConfirm}>Подтвердить</Button>
    </DialogActions>
  </Dialog>
);
